var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightningBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.628 9.342A.746.746 0 0018 9h-5.25V.75a.75.75 0 00-1.436-.304l-6 13.5A.748.748 0 006 15h5.25v8.25a.75.75 0 001.435.305l6-13.5a.748.748 0 00-.057-.713z",
    fill: "#FAAD14"
  })));
}

export default __webpack_public_path__ + "./fonts/lightning-bolt.fbdea44c0a1c9bbf41e416070cf56aa8.svg";
export { SvgLightningBolt as ReactComponent };